import { Engine } from ".";
import { MathUtils } from "./utils/MathUtils";

export class SuicideSoldier {

    public l: number;
    public x: number;
    public y: number;
    public detonateBomb: boolean;
    public explosionRange: number;

    private engine: Engine;
    private path:  {r: number, c: number}[];
    private speed: number;
    
    constructor (engine: Engine, path: {r: number, c: number}[]) {
        
        this.engine = engine;
        this.path = [];

        // le damos la vuelta a las celdas del path pq va en camino inverso
        for (let i = path.length - 1; i >= 0; i --) {
            this.path.push(path[i]);
        }

        this.l = 0;
        this.speed = .5;
        this.detonateBomb = false;
        this.explosionRange = 2.5;

        const p = MathUtils.getPathPosition(this.l, this.path);

        this.x = p.x;
        this.y = p.y; 
    }

    public destroy(): void {
        // nada
    }

    public update(): void {
        
        this.l = MathUtils.fixNumber(this.l + this.speed);

        if (this.l >= this.path.length) {

            this.x = this.path[this.path.length - 1].c;
            this.y = this.path[this.path.length - 1].r;

            this.engine.onSuicideSoldierReachedExit();

        } else {

            const p = MathUtils.getPathPosition(this.l, this.path);

            this.x = p.x;
            this.y = p.y;
        }
    }
}
